import { render, staticRenderFns } from "./index.vue?vue&type=template&id=584dacb4&scoped=true&style=margin-bottom%3A%20160px%3B%20margin-top%3A%2010px%3B"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=584dacb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584dacb4",
  null
  
)

export default component.exports